// 009 FR-045 (P-CART-8): each order number, school and total, the total paid, method and address,
// with Track order (the first order's detail, 011) and Continue shopping. Without a just-paid checkout (a reload), it sends
// the parent to My orders.
import { Link, Redirect } from "expo-router";
import { ScrollView, StyleSheet, View } from "react-native";

import { formatPaise } from "@/shop/format";
import { makeStyles } from "@/theme/makeStyles";
import { Button } from "@/ui/Button";
import { Text } from "@/ui/Text";

import { CHECKOUT_COPY as C } from "./copy";
import { lastCheckout } from "./lastCheckout";

const useStyles = makeStyles((t) =>
  StyleSheet.create({
    root: { flex: 1, backgroundColor: t.color.background },
    page: {
      width: "100%",
      maxWidth: 640,
      alignSelf: "center",
      padding: t.space.lg,
      gap: t.space.lg,
    },
    card: {
      borderRadius: t.radius.card,
      backgroundColor: t.color.surface,
      padding: t.space.lg,
      gap: t.space.sm,
    },
    row: {
      flexDirection: "row",
      justifyContent: "space-between",
      gap: t.space.md,
    },
  }),
);

export function ConfirmationScreen() {
  const styles = useStyles();
  const last = lastCheckout.get();
  if (!last) return <Redirect href="/orders" />;
  const { checkout, address } = last;
  return (
    <ScrollView style={styles.root} testID="order-placed">
      <View style={styles.page} role="main">
        <Text variant="display" accessibilityRole="header" aria-level={1}>
          {C.confirmedTitle}
        </Text>
        <Text>{C.confirmedLead(checkout.orders.length)}</Text>
        <View style={styles.card}>
          {checkout.orders.map((o) => (
            <View key={o.id} style={styles.row}>
              <View>
                <Text weight="bold">{`#${o.number}`}</Text>
                <Text size="sm" tone="muted">
                  {o.schoolName}
                </Text>
              </View>
              <Text weight="semiBold">{formatPaise(o.totalInPaise)}</Text>
            </View>
          ))}
          <View style={styles.row}>
            <Text weight="bold">{C.paid}</Text>
            <Text weight="bold">{formatPaise(checkout.totalInPaise)}</Text>
          </View>
          <Text size="sm" tone="muted">
            {C.methods[checkout.paymentMethod].label}
          </Text>
          <Text size="sm" tone="muted">
            {address}
          </Text>
        </View>
        <Link
          href={{
            pathname: "/orders/[orderId]",
            params: { orderId: checkout.orders[0]!.id },
          }}
          asChild
        >
          <Button accessibilityRole="link">{C.trackOrder}</Button>
        </Link>
        <Link href="/" asChild>
          <Button variant="outline" accessibilityRole="link">
            {C.continueShopping}
          </Button>
        </Link>
      </View>
    </ScrollView>
  );
}
